import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import PaginationDisplay from './PaginationDisplay';
import MobileSelector from './MobileSelector';

import reebok from '../../images/reebok.svg';
import rp from '../../images/rp.svg';
import concept2 from '../../images/concept2.svg';
import romwod from '../../images/romwod.svg';

import './Footer.css';

const styles = theme => ({
  containerWrap: {
    padding: '20px'
  },
  paddingHack: {
    paddingTop: '9px;'
  },
  // I hate this!
  buttonColorHack: {
    color: '#fff !important',
    transition: '0.2s all',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#000 !important'
    },
  },
});


class Footer extends Component {
  render() {
    return(
      <div className="container-footer">

        <div className="sponsor-logos ph1 pv3 mt3">
          <Grid 
            justify="center"
            alignItems="center"
            container
            className="tc">
            <Grid 
              item 
              xs={3}>
              <a 
                href="https://reebok.com?utm_source=crossfit-btwb&utm_medium=leaderboard&utm-campaign=rogue-qualifier-2019"
                target="_blank"
                rel="noopener noreferrer">
                <img alt="reebok" height="14" src={reebok} />
              </a>
            </Grid>
            <Grid
              item 
              xs={3}>
              <a 
                href="https://renaissanceperiodization.com?utm_source=crossfit-btwb&utm_medium=leaderboard&utm-campaign=rogue-qualifier-2019"
                target="_blank"
                rel="noopener noreferrer">
                <img alt="renaissance periodization" height="16" src={rp} />
              </a>
            </Grid>
            <Grid
              item 
              xs={3}>
              <a 
                href="https://romwod.com?utm_source=crossfit-btwb&utm_medium=leaderboard&utm-campaign=rogue-qualifier-2019"
                target="_blank"
                rel="noopener noreferrer">
                <img alt="RomWod" height="18" src={romwod} />
              </a>
            </Grid>
            <Grid 
              item 
              xs={3}>
              <a 
                href="https://www.concept2.com?utm_source=crossfit-btwb&utm_medium=leaderboard&utm-campaign=rogue-qualifier-2019"
                target="_blank"
                rel="noopener noreferrer">
                <img alt="Concept2" height="14" src={concept2} />
              </a>
            </Grid>
          </Grid>
        </div>

        <div className="w-100 fixed bottom-0 left-0 bg-black t-white z-5">
          <Grid 
            container
            className="pa2"
            justify={this.props.howManyToShow > 1 ? 'space-between' : 'space-around'}>
            {this.props.howManyToShow > 1 &&
              <Button
                variant="contained"
                className={'button ' + this.props.classes.paddingHack + ' ' + this.props.classes.buttonColorHack}
                color="primary"
                disabled={this.props.activeIdx <= 1}
                style={{
                  opacity: (this.props.activeIdx <= 1 ? '0.2' : '1')
                }}
                onClick={this.props.decreaseIdx}>
                <svg xmlns="http://www.w3.org/2000/svg" className="mr2 arrow arrow-right" viewBox="0 0 24 24" height="18px" width="18px">
                  <path d="M 10 4.9296875 L 2.9296875 12 L 10 19.070312 L 11.5 17.570312 L 6.9296875 13 L 21 13 L 21 11 L 6.9296875 11 L 11.5 6.4296875 L 10 4.9296875 z"/>
                </svg>
                <div className="dn db-ns">Back</div>
              </Button> 
            }
            <Grid 
              item>
              <PaginationDisplay 
                currentPageNumber={this.props.currentPageNumber}
                lastPageNumber={this.props.lastPageNumber} 
                updatePage={this.props.updatePage} 
                getLeaderboard={this.props.getLeaderboard}
              />
            </Grid>
            {this.props.howManyToShow > 1 &&
              <Button
                variant="contained"
                className={'button ' + this.props.classes.paddingHack + ' ' + this.props.classes.buttonColorHack}
                color="primary"
                disabled={this.props.activeIdx >= this.props.maxIdx - this.props.howManyToShow}
                style={{
                  opacity: (this.props.activeIdx >= this.props.maxIdx - this.props.howManyToShow ? '0.2' : '1')
                }}
                onClick={this.props.increaseIdx}>
                <div className="dn db-ns">Next</div> 
                <svg xmlns="http://www.w3.org/2000/svg" className="ml2 arrow arrow-right" viewBox="0 0 24 24" height="18px" width="18px">
                  <path d="M 14 4.9296875 L 12.5 6.4296875 L 17.070312 11 L 3 11 L 3 13 L 17.070312 13 L 12.5 17.570312 L 14 19.070312 L 21.070312 12 L 14 4.9296875 z"/>
                </svg>
              </Button> 
            }
          </Grid>
          <MobileSelector 
            activeIdx={this.props.activeIdx}
            maxIdx={this.props.maxIdx}
            howManyToShow={this.props.howManyToShow}
            selectIdx={this.props.selectIdx}
          />
        </div>
      </div>
    )
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  increaseIdx: PropTypes.func.isRequired,
  decreaseIdx: PropTypes.func.isRequired,
  activeIdx: PropTypes.number.isRequired,
  howManyToShow: PropTypes.number.isRequired,
  maxIdx: PropTypes.number.isRequired,
  updatePage: PropTypes.func.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  lastPageNumber: PropTypes.number,
  selectIdx: PropTypes.func.isRequired,
  getLeaderboard: PropTypes.func.isRequired
}

export default withStyles(styles)(Footer);